<template>
  <div class="deal">
    <van-nav-bar
      class="nav"
      :z-index="99"
      @click-left="onClickLeft"
    >
      <div slot="left"><van-icon name="arrow-left" color="#333333"  size=".5rem"/></div>
      <div slot="title" class="overell">{{title}}</div>
    </van-nav-bar>
    <iframe class="iframe white" :src="url" frameborder="0" :style="{'height': height-50 + 'px'}"></iframe>
  </div>
</template>

<script>
export default {
  props: {
    title: '',
    url: ''
  },
  data () {
    return {
      beforeStr: window.g.BeforeURL,
      height: '',
      width: ''
    }
  },
  filters: {
  },
  created () {
    this.height = document.getElementById('app').clientHeight
    this.width = document.getElementById('app').clientWidth
    // this.id = this.$route.query.id
    // this.title = this.$route.query.title
    // this.url = this.$route.query.url
  },
  methods: {
    onClickLeft () {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>
  .deal{
    font-family: 'PingFang-SC-Bold';
    position: relative;
  }
  .deal .iframe{
    /*margin-top: 1.7rem;*/
    width: 100%;
    position: absolute;
    top: 50px;/*no*/
    left: 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/common/popRule.vue